import MedCardIcon from "assets/menu-icons/MedCardIcon";

// Доработка 25. Раздел виден не по restricted (= подтверждённая регистрация, isVerified), а по
// requiresMedCard: достаточно любой доступной медкарты - своей либо члена семьи
// (useAuth().hasMedCard, см. Navigation/index.jsx). Карта ребёнка подтверждается независимо от
// карты родителя, поэтому по restricted раздел прятался и тогда, когда данные уже есть.
const medCard = {
  id: 'group-dashboard',
  type: 'group',
  requiresMedCard: true,
  visible: true,
  children: [
    {
      id: 'medCard',
      title: 'Медкарта',
      type: 'item',
      url: 'medCard',
      icon: MedCardIcon,
      breadcrumbs: false,
      requiresMedCard: true,
    },
  ]
};

export default medCard;